/**
 * @generated SignedSource<<28c050148562dae6107835d405b1ffb5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MutationsDeactivateSimCardMutation$variables = {
  documentId: string;
};
export type MutationsDeactivateSimCardMutation$data = {
  readonly deactivateSimCard: string;
};
export type MutationsDeactivateSimCardMutation = {
  response: MutationsDeactivateSimCardMutation$data;
  variables: MutationsDeactivateSimCardMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "documentId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "documentId",
        "variableName": "documentId"
      }
    ],
    "kind": "ScalarField",
    "name": "deactivateSimCard",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MutationsDeactivateSimCardMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MutationsDeactivateSimCardMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a832fb257814293d7ff28c7c14cc3428",
    "id": null,
    "metadata": {},
    "name": "MutationsDeactivateSimCardMutation",
    "operationKind": "mutation",
    "text": "mutation MutationsDeactivateSimCardMutation(\n  $documentId: ID!\n) {\n  deactivateSimCard(documentId: $documentId)\n}\n"
  }
};
})();

(node as any).hash = "2245fce83a01e320dd0e4b57b1017551";

export default node;
